export const fiveStars = (productsObject) => {
  const Keys = Object.keys(productsObject)
  Keys.map(key => (
    productsObject[key].map(item => item.rating = 5)
  ));
  
  return  productsObject;
}